<template>
  <div>
    <nav-bar />
    <h3>装修视频</h3>
    <ul class="videoList">
      <li v-for="item in VideoList" :key="item.id" @click="toVideo(item.id)">
        <img :src="[item.cover]" alt />
        <div class="journal_item_info">
          <h5>{{ item.title }}</h5>
          <span>{{ item.span }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import NavBar from "@/components/common/Navbar.vue";

export default {
  name: "",
  components: {
    NavBar,
  },
  props: {},
  data() {
    return {
      VideoList: [],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.getVideo();
  },
  methods: {
    async getVideo() {
      const res = await this.$http.get("/home/api/getvideo");
      console.log(res.data);
      let Item = "";
      for (let i = 0; i < res.data.length; i++) {
        Item = {
          cover: res.data[i].cover,
          videopath: res.data[i].videopath,
          title: res.data[i].title,
          id: res.data[i].id,
        };
        this.VideoList.push(Item);
      }
      console.log(this.VideoList);
    },
    async toVideo(id) {
      console.log(id);
      this.$router.push({ path: "/Video", query: { id: id } });
    },
  },
};
</script>

<style scoped lang="scss">
h3 {
  background-color: #fff;
  margin: 0;
  margin-top: 45px;
  padding-left: 20px;
  font-size: 16px;
  line-height: 32px;
}
.videoList {
  // margin-top: 48px;
  padding: 10px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  li {
    position: relative;
    margin-bottom: 10px;
    width: 49%;

    img {
      width: 100%;
    }
    .cover {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 2;
      // background: url("../../assets/images/case1.png");
      background-repeat: "no-repeat";
      background-size: cover;
      background-position: center;
    }
    .journal_item_info {
      position: relative;
      z-index: 4;
      h5 {
        font-size: 8px;
        margin: 0;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      span {
        font-size: 12px;
        color: #fff;
      }
      .user_pic {
        position: absolute;
        bottom: 0px;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        overflow: hidden;
        img {
          width: 100%;
        }
      }
      p {
        position: absolute;
        left: 44px;
        bottom: 10px;
        font-size: 12px;
        color: #fff;
      }
    }
  }
}
</style>
